import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript If Else If Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript if else if tutorial for beginners.if else if in Javascript is used for making a decision. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript if else if,Javascript if else if for,javascript if else if,Javascript if else if for loop,Javascript continue,if else if foreach Javascript,Javascript foreach if else if,javascript if else function,javascript if else program,javascript if else condition example" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-if-else-if" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If else if Statement in Javascript</h1>
    <div className="first">
        <a href="/javascript-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    



<h2 className="headings">If-Else-If in Javascript Syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        

  {"\n"}
  <span className="qwerty-10">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}


  <span className="qwerty-5">else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}
  <span className="qwerty-10">else </span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}
 </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">If-Else-If Javascript Examples:
</h2>


<h2 className="headings">
      Q-Write a program to Check maximum no between three no in Javascript?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">ab</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">20; </span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">cd</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">40; </span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">ef</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">60; </span>
            {"\n"}
            <span className="qwerty-5">&nbsp;&nbsp;if</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">ab</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">cd</span>
            <span className="qwerty-8"> && </span>
            <span className="qwerty-4">ab</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">ef</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"ab"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}

            <span className="qwerty-5">&nbsp;&nbsp;else if</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">cd</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">ab</span>
            <span className="qwerty-8"> && </span>
            <span className="qwerty-4">cd</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">ef</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"cd"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-5">&nbsp;&nbsp;else</span>
            {"\n"}

            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"ef"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}

            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;ef </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>




<h2 className="headings">
    Q-Write a program to Check no is Positive, Negative, Zero in Javascript If Else If?
    </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">i</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">46; </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;&nbsp;if</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">i</span>
          <span className="qwerty-8">&#60;</span>
          <span className="qwerty-1">0</span>
          <span className="qwerty-1">)</span>
          {"\n"}

          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-1">"negative"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}

          <span className="qwerty-5">&nbsp;&nbsp;else if</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">i</span>
          <span className="qwerty-8">&#62;</span>
          <span className="qwerty-1">0</span>
          <span className="qwerty-1">)</span>
          {"\n"}

          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-1">"positive"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;&nbsp;else</span>
          {"\n"}

          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-1">"zero"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;positive </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/javascript-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csifelseif;